// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"499":"bddb6ed6","787":"78ac8de9","895":"a1aa2524"}[chunkId] + ".chunk.js";
};